/*! @pentacode/ui v0.1.0 */
// \0@oxc-project+runtime@0.156.0/helpers/esm/decorateMetadata.js
function e(e, t) {
	if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, t);
}
export { e as t };
